export const getCookieValue = (cookieName: string): string => {
	const name = cookieName + '=';
	const decodedCookie = decodeURIComponent(document.cookie);
	const arrCookies = decodedCookie.split(';');

	for (let cookie of arrCookies) {
		// Avoid empty spaces
		while (cookie.charAt(0) === ' ') {
			cookie = cookie.substring(1);
		}

		// Found
		if (cookie.indexOf(name) === 0) {
			return cookie.substring(name.length, cookie.length);
		}
	}

	return '';
};
